import { DiscountCard } from './discount-card'

export default DiscountCard
